
export enum TokenState {
    undefined,
    valid,
    expired
}